import { type InmateDeviceFilters } from '@reliance/types/filters/InmateDeviceFilters';
import { type InmateDevice } from '@reliance/types/models/InmateDevice';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiService } from '../types/ApiService';

export type InmateDeviceAssignRequest = {
  account: string;
  deviceId?: number;
  facilityId?: number;
  externalFacilityId?: string;
};

export const inmateDevice = (siteApi: ApiService) => ({
  getByInmate: (inmateId: number): Promise<PaginatedResponse<InmateDevice>> => {
    const params: Pick<InmateDeviceFilters, 'inmateId'> = { inmateId };
    return siteApi.get<PaginatedResponse<InmateDevice>>('/inmate-device', {
      params,
    });
  },
  post: (data: InmateDeviceAssignRequest): Promise<InmateDevice> => {
    return siteApi.post<InmateDeviceAssignRequest, InmateDevice>(
      '/inmate-device',
      data,
    );
  },
  delete: (account: string): Promise<{ success: boolean }> => {
    return siteApi.delete<{ success: boolean }>(`/inmate-device/${account}`);
  },
});
